// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ZVBxv","hidden":"Loader_hidden__jsgxj","fadeOut":"Loader_fadeOut__jiimT"};